<template>
  <el-form :model="form" ref="formRef" :rules="proximityResultRule">
    <el-row>
      <el-col :span="3" :offset="14" class="text-xs align-middle">
        <input-label :required="labelRequired">実施日</input-label>
      </el-col>
      <el-col :span="7">
        <el-form-item
          prop="proximity.prior_discussion_date"
          v-if="proximityResultType === ProximityResultType.PREDISCUSSION"
          class="proximity_result_date"
        >
          <jr-date-picker
            class="prior_discussion_date"
            size="small"
            v-model="form.proximity.prior_discussion_date"
            :disabled="disabled"
            :isEdit="isEdit"
          />
        </el-form-item>
        <el-form-item
          prop="proximity.witness_date"
          v-else-if="proximityResultType === ProximityResultType.ONSITE"
          class="proximity_result_date"
        >
          <jr-date-picker
            class="witness_date"
            size="small"
            v-model="form.proximity.witness_date"
            :disabled="disabled"
            :isEdit="isEdit"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="mt-2">
      <el-col :span="5" class="text-xs align-middle">
        <input-label :required="labelRequired">工事内容</input-label>
      </el-col>
      <el-col :span="19">
        <el-form-item prop="proximity.construction_detail" class="proximity_construction_detail">
          <jr-text
            class="construction_detail"
            :disabled="disabled"
            :isEdit="isEdit"
            size="small"
            v-model="form.proximity.construction_detail"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="mt-2">
      <el-col :span="5" class="text-xs align-middle">
        <input-label :required="labelRequired">工事種別</input-label>
      </el-col>
      <el-col :span="9">
        <el-form-item prop="proximity.construction_type" class="proximity_construction_type">
          <Suspense>
            <construction-type-select
              class="construction_type"
              :disabled="disabled"
              :isEdit="isEdit"
              size="small"
              v-model="form.proximity.construction_type"
            />
          </Suspense>
        </el-form-item>
      </el-col>
      <el-col :span="10">
        <form-item-disabled
          prop="proximity.construction_type_other"
          class="proximity_construction_type_other"
          :disabled="form.proximity.construction_type !== constructionTypeOther"
        >
          <jr-text
            class="construction_type_other"
            :disabled="form.proximity.construction_type !== constructionTypeOther"
            :isEdit="isEdit"
            size="small"
            v-model="form.proximity.construction_type_other"
          />
        </form-item-disabled>
      </el-col>
    </el-row>
    <el-row class="mt-2">
      <el-col :span="7" class="text-xs align-middle">
        <input-label :required="labelRequired">工事用重機械の使用の有無</input-label>
      </el-col>
      <el-col :span="7">
        <el-form-item prop="proximity.is_use_heavy" class="proximity_is_use_heavy">
          <jr-radio-group
            radioClass="is_use_heavy-radio"
            :disabled="disabled"
            :isEdit="isEdit"
            :labels="availableLabels"
            v-model="form.proximity.is_use_heavy"
            size="small"
          />
        </el-form-item>
      </el-col>
      <el-col :span="10">
        <form-item-disabled
          prop="proximity.use_heavy_remark"
          :disabled="form.proximity.is_use_heavy !== true"
          class="proximity_use_heavy_remark"
        >
          <jr-text
            class="use_heavy_remark"
            :disabled="form.proximity.is_use_heavy !== true"
            :isEdit="isEdit"
            size="small"
            v-model="form.proximity.use_heavy_remark"
            placeholder="使用重機械"
          />
        </form-item-disabled>
      </el-col>
    </el-row>
    <el-row class="mt-2">
      <el-col :span="7" class="text-xs align-middle">
        <input-label :required="labelRequired">基礎工事の有無</input-label>
      </el-col>
      <el-col :span="7">
        <el-form-item prop="proximity.is_foundation_work" class="proximity_is_foundation_work">
          <jr-radio-group
            radioClass="is_foundation_work-radio"
            :disabled="disabled"
            :isEdit="isEdit"
            :labels="availableLabels"
            v-model="form.proximity.is_foundation_work"
            size="small"
          />
        </el-form-item>
      </el-col>
      <el-col :span="10">
        <form-item-disabled
          prop="proximity.foundation_work_remark"
          class="proximity_foundation_work_remark"
          :disabled="form.proximity.is_foundation_work !== true"
        >
          <jr-text
            class="foundation_work_remark"
            :disabled="form.proximity.is_foundation_work !== true"
            :isEdit="isEdit"
            size="small"
            v-model="form.proximity.foundation_work_remark"
            placeholder="直接基礎・杭基礎"
          />
        </form-item-disabled>
      </el-col>
    </el-row>
    <el-row class="mt-2">
      <el-col :span="7" class="text-xs align-middle">
        <input-label :required="labelRequired">地盤改良等の有無</input-label>
      </el-col>
      <el-col :span="7">
        <el-form-item prop="proximity.is_ground_completion" class="proximity_is_ground_completion">
          <jr-radio-group
            radioClass="is_ground_completion-radio"
            :disabled="disabled"
            :isEdit="isEdit"
            :labels="availableLabels"
            v-model="form.proximity.is_ground_completion"
            size="small"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="mt-2">
      <el-col :span="7" class="text-xs align-middle">
        <input-label :required="labelRequired">当社用地使用の有無</input-label>
      </el-col>
      <el-col :span="7">
        <el-form-item prop="proximity.is_use_out_land" class="proximity_is_use_out_land">
          <jr-radio-group
            radioClass="is_use_out_land-radio"
            :disabled="disabled"
            :isEdit="isEdit"
            :labels="availableLabels"
            v-model="form.proximity.is_use_out_land"
            size="small"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="mt-2">
      <el-col :span="7" class="text-xs align-middle">
        <input-label :required="labelRequired">線路内立入防護設備等有無</input-label>
      </el-col>
      <el-col :span="7">
        <el-form-item prop="proximity.is_without_protective" class="proximity_is_without_protective">
          <jr-radio-group
            radioClass="is_without_protective-radio"
            :disabled="disabled"
            :isEdit="isEdit"
            :labels="availableLabels"
            v-model="form.proximity.is_without_protective"
            size="small"
          />
        </el-form-item>
      </el-col>
      <el-col :span="10">
        <form-item-disabled
          prop="proximity.without_protective_remark"
          class="proximity_without_protective_remark"
          :disabled="form.proximity.is_without_protective !== true"
        >
          <jr-text
            class="without_protective_remark"
            :disabled="form.proximity.is_without_protective !== true"
            :isEdit="isEdit"
            size="small"
            v-model="form.proximity.without_protective_remark"
          />
        </form-item-disabled>
      </el-col>
    </el-row>
    <el-row class="mt-2">
      <el-col :span="7" class="text-xs align-middle">
        <input-label :required="labelRequired">施行予定期間</input-label>
      </el-col>
      <el-col :span="12">
        <el-form-item prop="proximity.end_plan_date" class="proximity_end_plan_date end_plan_date_error">
          <el-form-item prop="proximity.start_plan_date" class="proximity_start_plan_date">
            <jr-date-range-picker
              class="plan_date-range-picker"
              :isEdit="isEdit"
              v-model:start="form.proximity.start_plan_date"
              v-model:end="form.proximity.end_plan_date"
              size="small"
            />
          </el-form-item>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="mt-5">
      <el-col class="text-xs">
        <input-label>備考欄</input-label>
      </el-col>
    </el-row>
    <el-row class="mt-2">
      <el-col class="text-xs">
        <!-- 事前協議用の備考と現地立会の備考をURLで判断する -->
        <template v-if="proximityResultType === ProximityResultType.PREDISCUSSION">
          <el-form-item prop="proximity.prior_discussion_remark" class="proximity_prior_discussion_remark">
            <jr-textarea
              class="remark"
              :rows="10"
              v-model="form.proximity.prior_discussion_remark"
              :isEdit="isEdit"
              size="small"
            />
          </el-form-item>
        </template>
        <template v-else-if="proximityResultType === ProximityResultType.ONSITE">
          <el-form-item prop="proximity.witness_remark" class="proximity_witness_remark">
            <jr-textarea
              class="remark"
              :rows="10"
              v-model="form.proximity.witness_remark"
              :isEdit="isEdit"
              size="small"
            />
          </el-form-item>
        </template>
      </el-col>
    </el-row>
  </el-form>
</template>

<script lang="ts">
import { defineComponent, ref, watch, reactive } from 'vue'
import { ElForm } from 'element-plus'
import { AxiosResponse } from 'axios'

import InputLabel from '@/components/inputs/InputLabel.vue'
import JrDatePicker from '@/components/jr-parts/JrDatePicker.vue'
import JrText from '@/components/jr-parts/JrText.vue'
import ConstructionTypeSelect from '@/components/inputs/ConstructionTypeSelect.vue'
import JrRadioGroup, { availableLabels } from '@/components/jr-parts/JrRadioGroup.vue'
import JrDateRangePicker from '@/components/jr-parts/JrDateRangePicker.vue'
import JrTextarea from '@/components/jr-parts/JrTextarea.vue'
import FormItemDisabled from '@/components/layout/FormItemDisabled.vue'
import { proximityResultRule } from '@/constants/rules/proximity'

import { RequestHeaderProximityForm } from '@/types/forms'
import { ProximityResultType, RequestTypes } from '@/constants/enums'
import { ConstructionTypes } from '@/constants/enums'
import { isAfterToday } from '@/services/date'
import { ListRequest } from '@/requests/proximityHistory'
import { ProximityHistory } from '@/api'
import { useRouter } from 'vue-router'
import Logger from '@/services/logger'

export default defineComponent({
  name: 'ProximityResult',
  emits: ['update:form', 'update:formRef'],
  components: {
    JrDatePicker,
    InputLabel,
    JrText,
    ConstructionTypeSelect,
    JrTextarea,
    JrRadioGroup,
    JrDateRangePicker,
    FormItemDisabled,
  },
  props: {
    // 申請基本ID
    requestHeaderId: {
      type: Number,
      required: true,
    },
    // 編集可能か
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    //近接工事結果種別
    proximityResultType: {
      type: Number,
      required: true,
    },
    modelValue: {
      type: Object as () => RequestHeaderProximityForm,
      require: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    labelRequired: {
      type: Boolean,
      require: false,
      default: false,
    },
    messageId: {
      type: Number,
      require: false,
    },
  },
  setup(props, context) {
    const router = useRouter()
    const formRef = ref<InstanceType<typeof ElForm>>()
    const form = reactive<RequestHeaderProximityForm>({
      request_header_id: undefined,
      request_type: RequestTypes.PROXIMITY,
      applicant_number: '',
      applicant_time: '',
      department: -1,
      applicant_title: '',
      meter: undefined,
      applicant_email: '',
      applicant_business_name: '',
      applicant_manager_name: '',
      applicant_address: '',
      applicant_tel: '',
      is_tanto_department_login_user: false,
      proximity: {
        request_header: -1,
        construction_address: '',
        construction_building_name: '',
        line: '',
        line_name: '',
        start_station: -1,
        start_station_name: '',
        end_station: -1,
        end_station_name: '',
        degree: '',
        construction_latitude: '',
        construction_longitude: '',
        construction_detail: '',
        construction_type: -1,
        construction_type_other: null,
        construction_purpose: '',
        is_use_heavy: false,
        use_heavy_remark: null,
        is_foundation_work: false,
        foundation_work_remark: null,
        is_ground_completion: false,
        is_use_out_land: false,
        is_without_protective: false,
        without_protective_remark: null,
        start_plan_date: '',
        end_plan_date: '',
        location_map_file: -1,
        location_map_file_selected: false,
        ground_plan_file: -1,
        ground_plan_file_selected: false,
        cross_section_file: -1,
        cross_section_file_selected: false,
        actual_place_photo_file: -1,
        actual_place_photo_file_selected: false,
        foundation_drawing_file: -1,
        foundation_drawing_file_selected: false,
        plan_temporary_work_file: -1,
        plan_temporary_work_file_selected: false,
        working_range_file: -1,
        working_range_file_selected: false,
        cadastral_map_file: -1,
        cadastral_map_file_selected: false,
        survey_drawing_of_acreage_file: -1,
        survey_drawing_of_acreage_file_selected: false,
        prior_discussion_date: '',
        witness_date: '',
      },
    })

    watch(
      () => props.messageId,
      async (messageId: number | undefined) => {
        if (messageId) {
          const request = new ListRequest(messageId)
          await request.exec()
          if (request.success) {
            const { data } = request.getResponse() as AxiosResponse<ProximityHistory[]>
            if (data.length == 0) {
              //履歴に紐つかないメッセージIDの場合は404ページに遷移
              Logger.info(`履歴に紐つかないメッセージIDです。${messageId}`)
              router.push({ name: 'NotFound' })
              return
            }

            Object.assign(form.proximity, data[0])
            //JRDatePicker Warning対策
            //APIからの結果で実施日がnullの場合は空文字にする。
            if (form.proximity.prior_discussion_date === null) {
              form.proximity.prior_discussion_date = ''
            }
          }
        }
      },
      { immediate: true }
    )

    watch(
      () => props.modelValue,
      () => {
        if (props.modelValue) {
          Object.assign(form, props.modelValue)

          //JRDatePicker Warning対策
          //APIからの結果で実施日がnullの場合は空文字にする。
          if (form.proximity.prior_discussion_date === null) {
            form.proximity.prior_discussion_date = ''
          }
          if (form.proximity.witness_date === null) {
            form.proximity.witness_date = ''
          }
        }
      },
      { immediate: true }
    )

    watch(
      () => form,
      () => {
        context.emit('update:form', form)
      },
      { deep: true }
    )

    watch(
      () => formRef,
      () => {
        context.emit('update:formRef', formRef)
      },
      { deep: true }
    )

    return {
      availableLabels,
      form,
      formRef,
      constructionTypeOther: ConstructionTypes.OTHER,
      isAfterToday,
      ProximityResultType,
      proximityResultRule,
    }
  },
})
</script>
